'use client';

import { LoadingSpinner } from '@shared/ui';
import * as React from 'react';

import { TVirtualListProps, useVirtualList } from '../model';

export function VirtualList({
  count,
  estimateSize,
  onBottomReached,
  overscan,
  scrollMode = 'container',
  className,
  isFetchingNextPage = false,
  children,
}: TVirtualListProps) {
  const { rootRef, rowVirtualizer, onScroll } = useVirtualList({
    count,
    estimateSize,
    onBottomReached,
    overscan,
    scrollMode,
  });

  const virtualItems = rowVirtualizer.getVirtualItems();
  const scrollMargin = rowVirtualizer.options.scrollMargin;
  const lastRenderedItem = virtualItems[virtualItems.length - 1];

  const listHeight =
    scrollMode === 'page' &&
    !isFetchingNextPage &&
    lastRenderedItem?.index === count - 1
      ? lastRenderedItem.start - scrollMargin + lastRenderedItem.size
      : rowVirtualizer.getTotalSize();

  return (
    <div
      ref={rootRef}
      onScroll={scrollMode === 'container' ? onScroll : undefined}
      className={className}
    >
      <div className='relative w-full' style={{ height: `${listHeight}px` }}>
        {virtualItems.map((virtualRow) => (
          <div
            key={virtualRow.key}
            data-index={virtualRow.index}
            ref={rowVirtualizer.measureElement}
            className='absolute left-0 top-0 w-full'
            style={{
              transform: `translateY(${
                scrollMode === 'page'
                  ? virtualRow.start - rowVirtualizer.options.scrollMargin
                  : virtualRow.start
              }px)`,
            }}
          >
            {children(virtualRow.index)}
          </div>
        ))}
      </div>

      {isFetchingNextPage && (
        <div className='flex justify-center py-3'>
          <LoadingSpinner className='text-pics scale-90' />
        </div>
      )}
    </div>
  );
}
